import { useQuery } from '@tanstack/vue-query';
import { validatorFactoryRecord } from '@laam/lib/validator';
import {
	type RewardsRatesResponse,
	RewardsRatesSchema,
} from '~/types/Checkout.ts';
import * as Sentry from '@sentry/vue';

const rewardsRatesValidator =
	validatorFactoryRecord<RewardsRatesResponse>(RewardsRatesSchema);

export const useRewardsRatesQuery = () => {
	const { data, error, isLoading, isError, isFetching } = useQuery({
		queryKey: ['rewards_rates'],
		staleTime: 600000, //10 minutes stale time
		retry: 2,
		refetchOnWindowFocus: false,

		queryFn: async () => {
			try {
				const api = createApiInstance();
				const response = await api.get('/logan/rewards/rates');

				if (response.status === 200) {
					try {
						return rewardsRatesValidator.verify(response.data);
					} catch (e) {
						const err = new Error('Failed to verify rewards rates data');
						Sentry.captureException(err, (scope) => {
							scope.setContext('errors', {
								error: e,
							});
							return scope;
						});
						console.error('Failed to verify rewards rates data', e);
						throw err;
					}
				}
				const error = new Error('Failed to fetch rewards rates');
				Sentry.captureException(error, (scope) => {
					scope.setContext('response', response.data);
					return scope;
				});
				throw error;
			} catch (error: any) {
				console.error('Failed to fetch rewards rates', error);
				Sentry.captureException(error);
				throw new Error(error.message);
			}
		},
	});

	return {
		data,
		error,
		isLoading,
		isError,
		isFetching,
	};
};
